import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    margin: theme.spacing(1, 1),
  },
  buttonStyle: {
    textTransform: 'none',
  },
  dialogWhiteSpace: {
    whiteSpace: 'pre-wrap',
  },
  stringTextTransform: {
    textTransform: 'none',
  },
}))

export default useStyles
